// Actions
const SET_BASELINE = "assembly/setBaseline";
const SET_PREVIEW  = "assembly/setPreview";
const SET_CURRENT  = "assembly/setCurrent";
const SET_SHOW     = "assembly/setShowPreview";
const CLEAR_KEY    = "assembly/clearKey";
const CLEAR_ALL    = "assembly/clearAll";
const SET_ASSEMBLY_COMPILING = "assembly/setAssemblyCompiling";
const CLEAR_BC = "assembly/clearBusinessCase";


// Action creators
export const setBaseline = (key, meta, payload) => ({ type: SET_BASELINE, key, meta, payload });
export const setPreview  = (key, meta, payload) => ({ type: SET_PREVIEW,  key, meta, payload });
export const setCurrent  = (key)                => ({ type: SET_CURRENT,  key });
export const setShowPreview = (value)           => ({ type: SET_SHOW,     value });
export const clearKey    = (key)                => ({ type: CLEAR_KEY,    key });
export const clearAll    = ()                   => ({ type: CLEAR_ALL });
export const setAssemblyCompiling = (value) => ({ type: SET_ASSEMBLY_COMPILING, value });
export const clearAssemblyForBusinessCase = (bcId) => ({ type: CLEAR_BC, bcId });

// State shape:
// {
//   byKey: {
//     [key]: { meta, baseline?, preview?, createdAt }
//   },
//   currentKey: string|null,
//   showPreview: boolean
// }
const initial = { byKey: {}, currentKey: null, showPreview: false, assemblyCompiling: false };

export default function assemblyReducer(state = initial, action) {
  switch (action.type) {
    case SET_BASELINE: {
      const cur = state.byKey[action.key] || { meta: action.meta, createdAt: Date.now() };
      return {
        ...state,
        byKey: {
          ...state.byKey,
          [action.key]: { ...cur, meta: action.meta, baseline: action.payload, createdAt: Date.now() },
        },
      };
    }
    case SET_PREVIEW: {
      const cur = state.byKey[action.key] || { meta: action.meta, createdAt: Date.now() };
      return {
        ...state,
        byKey: {
          ...state.byKey,
          [action.key]: { ...cur, meta: action.meta, preview: action.payload, createdAt: Date.now() },
        },
      };
    }
    case SET_CURRENT:
      return { ...state, currentKey: action.key };
    case SET_SHOW:
      return { ...state, showPreview: !!action.value };
    case CLEAR_KEY: {
      const byKey = { ...state.byKey };
      delete byKey[action.key];
      return {
        ...state,
        byKey,
        currentKey: state.currentKey === action.key ? null : state.currentKey,
        showPreview: state.currentKey === action.key ? false : state.showPreview,
      };
    }

    case CLEAR_BC: {
      const bcId = Number(action.bcId);
      const byKey = {};

      Object.entries(state.byKey).forEach(([key, bucket]) => {
        if (Number(bucket?.meta?.bcId) !== bcId) byKey[key] = bucket;
      });

      const currentGone = state.currentKey != null && !byKey[state.currentKey];

      return {
        ...state,
        byKey,
        currentKey: currentGone ? null : state.currentKey,
        showPreview: currentGone ? false : state.showPreview,
      };
    }

    case SET_ASSEMBLY_COMPILING:
      return { ...state, assemblyCompiling: !!action.value };
    case CLEAR_ALL:
      return initial;
    default:
      return state;
  }
}


// Selectors
export const selectAssemblyState = (s) => s.assembly || initial;
export const selectCurrentKey    = (s) => selectAssemblyState(s).currentKey;
export const selectShowPreview   = (s) => selectAssemblyState(s).showPreview;
export const selectBucketByKey   = (s, key) => selectAssemblyState(s).byKey[key] || null;
export const selectActiveResult = (s) => {
  const { byKey, currentKey, showPreview } = selectAssemblyState(s);
  const bucket = currentKey ? byKey[currentKey] : null;
  if (!bucket) return null;

  const raw = showPreview ? bucket.preview : bucket.baseline;
  if (!raw) return null;

  return raw.assembledBusinessCase
  ? { ...raw, ...raw.assembledBusinessCase }
  : raw;
};
export const selectAssemblyCompiling = (s) => !!(s.assembly?.assemblyCompiling);

export const findAssemblyBucketForBusinessCase = ({
  assemblyState,
  bcId,
  allocationsHash,
  periodsHash,
  structureVersion,
}) => {
  const byKey = assemblyState?.byKey || {};

  return Object.entries(byKey).find(([, bucket]) => {
    const meta = bucket?.meta;
    if (!meta) return false;

    return (
      Number(meta.bcId) === Number(bcId) &&
      meta.allocationsHash === allocationsHash &&
      meta.periodsHash === periodsHash &&
      meta.structureVersion === structureVersion
    );
  }) || null;
};
